import React from 'react'
import {HashRouter} from 'react-router-dom';
import App from './App';

function RouterClass() {
  return (
    <HashRouter>
        <App></App>
    </HashRouter>
  )
}

export default RouterClass